// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-floating-bubble {\n  display: flex;\n  background: #1F6BC2;\n  width: 36px;\n  height: 36px;\n  border-radius: 18px;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n.gap-floating-bubble .icon {\n  width: 16px;\n  height: 16px;\n  margin: auto;\n}\n.gap-floating-bubble:hover {\n  background: #3584df;\n}\n.gap-floating-bubble:active {\n  background: #1F6BC2;\n}\n", ""]);
// Exports
module.exports = exports;
